import React, { Component } from 'react';
import './AdminHeader.css';

class AdminHeader extends Component {
	render() {
		if (this.props.data.recording.canManage === false) {
			return null;
		}

		let publishClass = '';

		if (this.props.data.recording.published === false) {
			publishClass = 'unpublished-notice';
		}

		return (
			<div className="admin-header Header content-header">
				<div className={publishClass}>{this.props.data.recording.published === false ? 'Recording is not published - only managers can see it.' : null }
					{this.props.data.recording ? <div className="manage-buttons"><a className="btn" href={"/leccap/manage/recording/edit/" + this.props.data.recording.sitekey + "/" + this.props.data.recording.id }>Manage Recording</a><a className="btn" href={"/leccap/manage/site/info/" + this.props.data.recording.sitekey }>Manage Site</a></div> : null }
				</div>
				<span className="clearfix"></span>
			</div>
		);
	}
}

export default AdminHeader;